/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import styled from "styled-components";
import "stylesheets/spectrum.scss";

export const SpectrumCssWrapper: React.FC = (props) => {
  return (
    <div
      style={{ backgroundColor: "var(--spectrum-global-color-static-white)" }}
    >
      {props.children}
    </div>
  );
};

export const ButtonFillXLarge = styled.button.attrs<{ className: string }>({
  className: "spectrum-Button spectrum-Button--fill spectrum-Button--sizeXL",
})``;

export const BodyLarge = styled.div.attrs(() => ({
  className: "spectrum-Body spectrum-Body--sizeL",
}))``;
